import React from 'react';

/** Renders a `label` element */
const FormLabel = ({ ...props }) => {
  return <label className="control-label" style={{ fontWeight: 400 }} {...props} />;
};

export default FormLabel;
